import { QDataRefreshRFC } from "./QDataRefreshRFC";
import { QUser } from "./QUser";

export class QUserSessionRFC extends QDataRefreshRFC {
  constructor() {
    super();
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    if (r["success"]) {
      if (r["sessionInfo"]) this.fWSMgr.UpdateUserSessionInfo(r["sessionInfo"]);
    }
  }
}
